import styled from 'styled-components/macro';

export const EmptyBlock = styled.div<{ collapsed: boolean }>`
  padding: 20px 0;
  display: ${(props) => (props.collapsed ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;
  color: #1f2939;
`;

export const TableHeader = styled.thead`
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  display: block;
  padding: 0 12px;
  border-radius: 12px 12px 0 0;
  border-bottom: 1px solid #e4e8ee;
  z-index: 5;

  & > tr {
    display: table;
    table-layout: fixed;
    width: 100%;

    & > th {
      color: #495466;
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;
      padding: 8px 0;
      text-align: left;
    }

    & > th:nth-child(3) {
      width: 50px;
    }

    & > th:nth-child(1) {
      @media (max-width: 1350px) {
        width: 111px;
      }
    }
  }
`;

export const MetersTable = styled.table<{ collapsed: boolean }>`
  position: relative;
  display: ${(props) => (props.collapsed ? 'none' : 'table')};
  width: -webkit-fill-available;
  width: -moz-available;
  border-spacing: 25px 0;
  border-collapse: separate;
  margin: 0 -25px;

  & .list-item-text {
    display: flex;
    align-items: center;
    text-align: left;
    gap: 8px;
    overflow: hidden;
    //white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const TableBody = styled.tbody`
  background-color: #ffffff;
  display: block;
  padding: 0 12px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const TitleWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const Title = styled.div`
  color: #495466;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding: 20px 8px;
`;

export const ToggleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoaderWrapper = styled.div<{ inCallCard: boolean }>`
  ${(props) =>
    props.inCallCard
      ? {
          display: 'flex',
          justifyContent: 'center',
          padding: '12px',
        }
      : {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
`;
